import { Component, OnInit } from "@angular/core";
import { UserService } from "../services/user.service";
import { NotificationsService } from "../services/notifications.service";
import {
  trigger,
  style,
  transition,
  animate,
  keyframes,
  query,
  stagger
} from "@angular/animations";
import { LogService } from "../services/log.service";
@Component({
  selector: "app-notifications",
  templateUrl: "./notifications.component.html",
  styleUrls: ["./notifications.component.css"],
  animations: [
    trigger("anim", [
      transition("* => *", [
        query(":enter", style({ opacity: 0 }), { optional: true }),
        query(
          ":enter",
          stagger("500ms", [
            animate(
              "1s ease-in",
              keyframes([
                style({
                  opacity: 0,
                  transform: "translateY(-15px)",
                  offset: 0
                }),
                style({
                  opacity: 0.5,
                  transform: "translateY(15px)",
                  offset: 0.3
                }),
                style({ opacity: 1, transform: "translateY(0)", offset: 1 })
              ])
            )
          ]),
          { optional: true }
        )
      ])
    ])
  ]
})
export class NotificationsComponent implements OnInit {
  public student_id;
  public notifications;
  public resp;
  constructor(
    private _userService: UserService,
    private _notificationsService: NotificationsService, public log: LogService
  ) {}

  ngOnInit() {
    this.log
      .addLog({
      action: "Access",
      component: "Notifications",
      details: `Accessed Notifications`,
    }).subscribe(data => { });
    this.resp = "";
    this._userService.getUserData().subscribe(data => {
      this.student_id = data.student_id;
      this._notificationsService
        .showNotifications(this.student_id)
        .subscribe(data => {
          this.notifications = data;
          if (this.notifications.length <= 0) {
            this.resp = "No notification";
          }
        });
    });
  }
}
